// prefix: serviceAccount

const DESCRIPTION = 'Descripción';
const EXPIRATION_DATE = 'Fecha de expiración';

export const serviceAccount = {
    sidebar: {
        title: 'Cuentas de Servicio'
    },
    list: {
        title: 'Cuentas de Servicio',
        subtitle: 'Crea y administra cuentas de servicio utilizadas por aplicaciones e integraciones.',
        new: 'Crear cuenta',
        myAccounts: 'Mis cuentas',
        search: 'Buscar cuenta...',
        paginationCount: '1 cuenta de servicio | {total} cuentas de servicio',
        loading: 'Buscando...',
        headers: {
            description: DESCRIPTION,
            expirationDate: EXPIRATION_DATE,
            status: 'Estatus'
        },
        badges: {
            ACTIVE: 'Activa',
            INACTIVE: 'Inactiva'
        },
        actions: {
            moreActions: 'Más acciones',
            viewKey: 'Ver clave',
            block: 'Bloquear',
            activate: 'Activar',
        },
        viewKeyModal: {
            title: 'Clave de la cuenta de servicio',
        },
        empty: {
            title: 'Por el momento no tienes cuentas de servicio',
            text: 'Aquí estará el listado de las cuentas de servicio que hayas creado.',
        },
    },
    modals: {
        block: {
            title: '¿Estás seguro de que quieres bloquear esta cuenta de servicio?',
            text: 'La aplicación o integración que utiliza esta credencial dejará de tener acceso mientras la cuenta se encuentre bloqueada.',
            buttonCancel: 'No',
            buttonText: 'Sí',
            toastSuccess: 'Se ha bloqueado la cuenta de servicio exitosamente.',
        },
        unblock: {
            title: '¿Estás seguro de que quieres activar esta cuenta de servicio?',
            text: 'Una vez activada, la aplicación o integración podrá volver a utilizar esta credencial con normalidad.',
            buttonCancel: 'No',
            buttonText: 'Sí',
            toastSuccess: 'Se ha activado la cuenta de servicio exitosamente.',
        },
    },
    new: {
        back: 'Regresar a cuentas de servicio',
        header: 'Nueva cuenta de servicio',
    },
    show: {
        title: 'Cuenta de servicio creada',
        subtitle: 'Guarda esta información, no podrás volver a consultar la clave secreta.',
        description: DESCRIPTION,
        expirationDate: EXPIRATION_DATE,
        key: 'Clave',
        secret: 'Clave secreta',
        copy: 'Copiar',
        copied: 'Se copió {label} al portapapeles',
    },
    form: {
        title: 'Configuración de cuenta',
        subtitle: 'Configure los datos y permisos de la nueva cuenta de servicio.',
        description: DESCRIPTION,
        descriptionPh: 'Describe el proposito de esta credencial',
        expirationDate: {
            label: EXPIRATION_DATE,
            help: 'Después de esta fecha, los permisos asociados dejarán de ser válidos.',
        },
        item: {
            headerDescription: 'CLABE {CLABE} · No. cuenta {accountNo}',
            CLIENTS_ACCOUNT: 'Cuenta de negocios',
            CORPORATE_ACCOUNT: 'Cuenta corporativa',
            USERS_ACCOUNT: 'Cuenta personal',
            actions: {
                collapse: 'Colapsar cuenta',
            },
            table: {
                headers: {
                    permissions: 'Permisos de servicio',
                    read: 'Lectura'
                },
                footer: {
                    edit: 'Editar permisos de cuenta',
                    save: 'Guardar',
                    cancel: 'Cancelar',
                }
            }
        },
    },
    NovaPermissions: {
        types: {
            Account: 'Acceso a la cuenta',
            Movements: 'Movimientos de cuenta',
            Statements: 'Estados de cuenta',
            CorporativeAccounts: 'Cuenta de corporativas',
        },
        actions: {
            READ: 'Lectura',
        },
    }

};

